var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class AlfatronSmw42 {
    constructor(socket, log) {
        this.socket = socket;
        this.apiState = 'username';
        this.duplicatedDisplay = false;
        this.inputState = {
            'TYPE-C': 'NoSignal',
            VGA: '1920x1080P@60 RGB888',
            HDMI1: 'NoSignal',
            HDMI2: '1920x2160P@28 RGB888',
            Dongle1: '1920x1080P@60 H264',
            Dongle2: 'NoSignal',
            Dongle3: 'NoSignal',
            Dongle4: 'NoSignal',
        };
        this.layouts = {
            '0x100': 'layout0',
            '0x101': 'layout1',
            '0x102': 'layout2',
            '0x103': 'layout3',
            '0x104': 'layout4',
            '0x105': 'layout5',
            '0x106': 'layout6',
            '0x107': 'layout7',
            '0x108': 'layout8',
        };
        this.timeouts = new Timeouts();
        this.videoOutputs = Array(2).fill('hdmi1');
        this.apiAsyncHandlers = [
            {
                name: 'audioSelect',
                regExp: /gbconfig --audio-select (.+)/i,
                callback: (match) => {
                    // no response for a valid selection
                },
            },
            {
                name: 'autoSwitch',
                regExp: /gbconfig --auto-switch-source (.+)/i,
                callback: (match) => {
                    // no response for the auto switch mode
                },
            },
            {
                name: 'duplicatedDisplay',
                regExp: /gbconfig --duplicated-dualoutput (.+)/i,
                callback: (match) => {
                    this.duplicatedDisplay = match[1] === 'y';
                    // no response for a valid selection
                },
            },
            {
                name: 'gblayout',
                regExp: /gblayout --auto (y|n)/i,
                callback: (match) => {
                    // no response to the control system
                },
            },
            {
                name: 'gblayoutList',
                regExp: /gblayout --list/i,
                callback: (match) => {
                    this.socket.send(`Layout #        Name:`);
                    for (let i in this.layouts) {
                        this.socket.send(`${i}       ${this.layouts[i]}`);
                    }
                },
            },
            {
                name: 'getRoute',
                regExp: /gbconfig --show source-select/i,
                callback: (match) => {
                    this.socket.send(`${this.videoOutputs[0].toUpperCase()}`);
                },
            },
            {
                name: 'getRouteSecondaryOutput',
                regExp: /gbconfig --show secondary-output/i,
                callback: (match) => {
                    this.socket.send(`${this.videoOutputs[1].toUpperCase()}`);
                },
            },
            {
                name: 'inputStateAll',
                regExp: /gbconfig --input-state$/i,
                callback: (match) => {
                    for (let i in this.inputState) {
                        this.socket.send(`${i}       ${this.inputState[i]}`);
                    }
                },
            },
            {
                name: 'inputState',
                regExp: /gbconfig --input-state (.+)/i,
                callback: (match) => {
                    this.socket.send(`${this.inputState[match[1]]}`);
                },
            },
            {
                name: 'layout',
                regExp: /gblayout --set (0x\d+)/i,
                callback: (match) => {
                    const layoutName = this.layouts[match[1]];
                    this.socket.send(`[Event] Layout ${match[1]} ${layoutName !== null && layoutName !== void 0 ? layoutName : 'layout0'}`);
                },
            },
            {
                name: 'setRoute',
                regExp: /gbconfig --source-select (.+)/i,
                callback: (match) => {
                    this.videoOutputs[0] = match[1];
                    if (this.duplicatedDisplay) {
                        this.videoOutputs[1] = match[1];
                    }
                    this.socket.send(`[Event] Layout 0x100 layout0`);
                },
            },
            {
                name: 'setRouteSecondaryOutput',
                regExp: /gbconfig --secondary-output (.+)/i,
                callback: (match) => {
                    this.videoOutputs[1] = match[1];
                    // no response from this command
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`-sh: ${match[0]}: not found`);
                },
            },
        ];
        this.authAsyncHandlers = [
            {
                regExp: /.+/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.apiState === 'username') {
                        this.apiState = 'password';
                        this.socket.sendRaw(`Password: `);
                        // Delay allows emulator to ignore the empty password and respond to allow the
                        // driver to continue connecting.
                        yield this.timeouts.delay(500);
                        this.apiState = 'authenticated';
                        this.socket.send(`Welcome to HiLinux`);
                        this.socket.sendRaw(`~ # `);
                        this.asyncHandlers = this.apiAsyncHandlers;
                    }
                }),
            },
        ];
        this.asyncHandlers = this.authAsyncHandlers;
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.apiState = 'username';
            this.asyncHandlers = this.authAsyncHandlers;
            yield this.timeouts.delay(1000);
            this.socket.sendRaw(`(none) login: `);
        });
    }
}
AlfatronSmw42.emulatorType = 'socketEmulator';
AlfatronSmw42.key = '-MYjKk2F4nA3FU9I4TtD';
